export const IMAGE_WIDTH = 320;
export const IMAGE_HEIGHT = 180;

export const TEXT_NAME_BEGINNING = 'catalogue.'